import { trustItems } from "./data.js";

export default function Trust() {
  return (
    <section className="bg-[#f7f4ff] px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-5xl rounded-[32px] border border-purple-100 bg-white px-8 py-10 text-center shadow-[0_20px_60px_rgba(124,58,237,0.08)] sm:px-12">
        <h2 className="text-3xl font-montserrat font-black tracking-[-0.03em] text-[#0d0828] sm:text-4xl">
          Your money is safe
        </h2>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          {trustItems.map((item, index) => (
            <div
              key={item}
              className="flex items-center gap-3 rounded-full border border-purple-100 bg-[#faf8ff] px-5 py-3 text-sm font-semibold text-[#0d0828] font-montserrat"
            >
              <span
                className={`h-2.5 w-2.5 rounded-full ${index === 0 ? "bg-green-500" : "bg-purple-300"
                  }`}
              />
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
